import {PartStateApiDto} from "./_RestModels";

export default class PartState {
	constructor(public readonly partId: string, public readonly quantity: number) {
	}

	public static fromJson(json: PartStateApiDto): PartState {
		return new PartState(json.partId, json.quantity);
	}
}